// AUTO-GENERATED CODE, DO NOT EDIT!
/* eslint-disable */

import * as Types from '../../../types';

import gql from 'graphql-tag';
import { VenueSustainableInitiativesVenueFragmentDoc } from '../../../Components/VenueSustainableInitiatives/VenueSustainableInitiatives.generated-types';
import { BestLayoutProposalFragmentDoc } from './BestLayout/BestLayout.generated-types';
import { DocumentsProposalFragmentDoc } from './Documents/Documents.generated-types';
import { GetAddressProposalFragmentDoc } from '../../../Graphql-Utilities/getAddress/getAddress.generated-types';
export type ProposalInfoCardProposalFragment = { __typename?: 'Proposal', UUID: string, ID: number, message?: string | null, currency: string, baseCostTotal: number, baseCostDescription: string, space: { __typename?: 'SelfServeSpace', spaceName?: string | null, description?: string | null, tour3dUrl?: string | null, hostContact: { __typename?: 'HostContact', avatar?: { __typename?: 'Avatar', normal?: string | null, small?: string | null, thumb?: string | null } | null }, spaceFeatures?: Array<{ __typename?: 'SelfServeSpaceFeature', ID?: number | null, name?: string | null }> | null, spaceDocuments?: Array<{ __typename?: 'SpaceDocument', url?: string | null, s3Key?: string | null, tag?: Types.SpaceDocumentTag | null, id?: number | null, filename?: string | null } | null> | null, venue?: { __typename?: 'SelfServeVenue', name?: string | null, latitude?: number | null, longitude?: number | null, addressLine1?: string | null, city?: string | null, postalCode?: string | null, ID?: number | null, nearestTransit?: { __typename?: 'NearestTransit', station?: string | null, distanceKm?: number | null } | null } | null, spatialConfigurations?: Array<{ __typename?: 'SelfServeSpatialConfiguration', name?: string | null, capacity?: number | null }> | null }, event: { __typename?: 'Event', UUID: string }, documents?: Array<{ __typename?: 'ProposalDocument', URL: string, s3Key: string, ID: number, filename: string }> | null };

export const ProposalInfoCardProposalFragmentDoc = gql`
    fragment ProposalInfoCardProposal on Proposal {
  UUID
  ID
  message
  currency
  baseCostTotal
  baseCostDescription
  space {
    spaceName
    description
    hostContact {
      avatar {
        normal
        small
        thumb
      }
    }
    spaceFeatures {
      ID
      name
    }
    spaceDocuments {
      url
      s3Key
      tag
      id
      filename
    }
    tour3dUrl
    venue {
      name
      nearestTransit {
        station
        distanceKm
      }
      latitude
      longitude
      ...VenueSustainableInitiativesVenue
    }
  }
  event {
    UUID
  }
  ...BestLayoutProposal
  ...DocumentsProposal
  ...GetAddressProposal
}
    ${VenueSustainableInitiativesVenueFragmentDoc}
${BestLayoutProposalFragmentDoc}
${DocumentsProposalFragmentDoc}
${GetAddressProposalFragmentDoc}`;